export interface ApiErrorInit {
  status: number;
  code: string;
  message: string;
  details?: unknown;
  requestId?: string | undefined;
  body?: unknown;
}

/**
 * Normalized error for every failed API call. Components show `message`;
 * `code` and `status` let callers branch without parsing strings.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: unknown;
  readonly requestId: string | undefined;
  readonly body: unknown;

  constructor({ status, code, message, details, requestId, body }: ApiErrorInit) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = requestId;
    this.body = body;
  }

  get isNetworkError(): boolean {
    return this.status === 0;
  }
}
